export default __webpack_public_path__ + "static/media/10.a69c15c1.jpg";